import { ResetProvider } from '../../../../components/account/ResetProvider';

export const Page = () => {
  return <ResetProvider />;
};
